import { useSettingsNavigationState } from 'services/settings/navigation';

export const useLite = () => {
  const {
    state: { isRenter },
  } = useSettingsNavigationState();

  return {
    isLite: isRenter,
  };
};
